namespace advisorop.components.widgets {

    export class ChartHdAccountsController {
        //chartColumnWidth: string = "col-lg-12";
        //chartPieWidth: string = "col-lg-6";
        //chartGridRow: string = "";
        showChart: boolean = true;
        showHistChart: boolean;
        histChartNote: string;
        histChartDataExists: boolean = false;
        clearHistChartData: boolean = false;
        localChartHide: boolean = false;
        chartInstance: any;
        histChartInstance: any = null;
        chartData: Array<domains.IChartDataSource>;
        histChartData: Array<domains.IChartDataSource>;
        advDash: boolean = false;
        iAmReady: any;
        data = [];
        dataBySecurity = [];
        dataProtectiveAssetClass = [];
        dataProtectiveGroup = [];
        dataProtective = [];
        chartTypes = [];
        selChartType;
        titleData: string;
        //histTitleData: string;
        dg: DevExpress.ui.dxDataGridOptions;
        dgBySecurity: DevExpress.ui.dxDataGridOptions;
        dgProtectiveAssetClass: DevExpress.ui.dxDataGridOptions;
        dgProtectiveGroup: DevExpress.ui.dxDataGridOptions;
        dgProtective: DevExpress.ui.dxDataGridOptions;
        masterChartTypeId: number = 0;
        currentChartTypeId: number = 0;
        stackPercentAttribute: boolean = true;

        chartId_BY_ACCOUNT_TYPE: number = 1;
        chartId_BY_ACCOUNT_STRATEGY: number = 2;
        chartId_BY_ASSET_CLASS: number = 3; // NOT USED CURRENTLY
        chartId_BY_ASSET_CLASS_CUSTOM: number = 4;
        chartId_BY_SECURITY_TYPE: number = 5;
        chartId_BY_SECURITY_CATEGORY: number = 6; // NOT USED CURRENTLY
        chartId_BY_SECURITY: number = 7;
        chartId_BY_ACCOUNT: number = 8;

        showCurrChart: boolean = true;
        allowProtectiveCharts: boolean = false;
        protectiveChartsEnabled: boolean = true;
        showProtChart: boolean = false;
        showProtAnalysis: boolean = false;
        selProtectiveChartType: number = 1;
        chartProtectiveGroupOptions;
        chartProtectiveAssetClassOptions;
        protectiveData: domains.IProtectiveComposition[] = [];
        protectiveSecurities: domains.ISecurityNote[] = [];
        piPopupOptions: DevExpress.ui.dxPopupOptions;
        scrollViewOptions: DevExpress.ui.dxScrollViewOptions;

        visibleProtectivePopup = false;
        protectiveInstrument: domains.ISecurityNote;

        // Secondary pie chart (drill-down for a selected slice)
        showSliceChart: boolean = false;
        showSliceChartRender: boolean = true;
        sliceTitle: string = "";
        selectedSliceLabel: string = "";
        allBySecurityData: domains.IChartData[] = [];
        // When the secondary pie shows child asset classes (custom plan with hierarchy),
        // this holds the flattened list of underlying securities used for the data grid.
        flattenedSecurities: domains.IChartData[] = [];
        chartSlice = {
            "chart": {
                "startingangle": "240",
                "showlabels": "1",
                "labelFontSize": "11",
                "labelFontBold": "1",
                "enableMultiSlicing": "0",
                "enableSmartLabels": "1",
                "manageLabelOverflow": "1",
                "useEllipsesWhenOverflow": "1",
                "pieRadius": "100",
                "slicingDistance": "12",
                "showValues": "1",
                "showPercentValues": "1",
                "showPercentInTooltip": "1",
                "decimals": "1",
                "showvalueintooltip": "1",
                "use3dlighting": "1",
                "radius3D": "10",
                "plottooltext": "$label, $percentvalue",
                "theme": "fint",
                "defaultAnimation": "0"
            },
            "data": []
        };

        chart = {
            "chart": {
                //"caption": this.titleData,      
                "startingangle": "240",
                "showlabels": "1",
                "labelFontSize": "11",
                "labelFontBold": "1",
                //"showLegend": "1",
                "enableMultiSlicing": "0",
                "enableSmartLabels": "1",
                "manageLabelOverflow": "1",
                "useEllipsesWhenOverflow": "1",
                "pieRadius": "100",
                "slicingDistance": "12",
                "showValues": "1",
                "showPercentValues": "1",
                "showPercentInTooltip": "1",
                "decimals": "1",
                "showvalueintooltip": "1",
                "use3dlighting": "1",
                "radius3D": "10",
                "plottooltext": "$label, $percentvalue",
                "theme": "fint",
                "defaultAnimation": "0"
            },
            "data": []
        };

        histChart = {
            "chart": {
                "showlabels": "1",
                "enableSmartLabels": "1",
                "manageLabelOverflow": "1",
                "useEllipsesWhenOverflow": "1",
                "showValues": "1",
                "showPercentValues": "1",
                "showPercentInTooltip": "1",
                "decimals": "2",
                "labelFontSize": "12",
                "valueFontSize": "12",
                "valueFontColor": "#000000",
                "valueFontBold": "1",
                "showvalueintooltip": "1",
                "theme": "fint",
                "labelDisplay": "rotate",
                "slantLabel": "1",
                "stack100Percent": "1",
                "interactiveLegend": "0",
                "defaultAnimation": "0"
            },
            categories: [],
            dataset: []
        };

        constructor(private advisorService: services.AdvisorService) {
            this.dg = {
                export: {
                    enabled: true,
                    fileName: "ChartData"
                },
                bindingOptions: {
                    dataSource: "vm.data"
                },
                //height: "350px",
                //width: "100%",
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                allowColumnResizing: true,
                columnResizingMode: "nextColumn",
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                onContentReady: (e: any) => {
                    //this.showHideResizeCols(e.component);
                },
                columns: [
                    { dataField: "label", caption: "Holding", width: 100 },
                    { dataField: "label2", caption: "Description" },
                    { dataField: "value", caption: "Value", format: "currency", sortOrder: "desc", width: 100 },
                    { dataField: "value3", caption: "% of Total", format: { type: "percent", precision: 1 }, width: 100 },
                    { dataField: "value2", caption: "Units", format: "fixedPoint", width: 100 }
                ],
                masterDetail: {
                    // enable this to see the breakdown by securities.
                    enabled: false,
                    template: "bySecurities",
                    autoExpandAll: false
                }
            };

            this.dgBySecurity = {
                //height: "350px",
                //width: "100%",
                bindingOptions: {
                    dataSource: "vm.dataBySecurity"
                },
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                allowColumnResizing: true,
                columnResizingMode: "nextColumn",
                //scrolling: {
                //    mode: "standard",
                //    useNative: true
                //},
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                onContentReady: (e: any) => {
                    //this.showHideResizeCols(e.component);
                },
                columns: [
                    { dataField: "label", caption: "Holding", width: 100 },
                    { dataField: "label2", caption: "Description" },
                    { dataField: "value", caption: "Value", format: "currency", sortOrder: "desc", width: 100 },
                    { dataField: "value3", caption: "% of Total", format: { type: "percent", precision: 1 }, width: 100 },
                    { dataField: "value2", caption: "Units", format: "fixedPoint", width: 100 }
                ],
            };

            this.dgProtectiveAssetClass = {
                export: {
                    enabled: true,
                    fileName: "ChartData"
                },
                bindingOptions: {
                    dataSource: "vm.dataProtectiveAssetClass"
                },
                //height: "350px",
                //width: "100%",
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                allowColumnResizing: true,
                columnResizingMode: "nextColumn",
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                onContentReady: (e: any) => {
                    //this.showHideResizeCols(e.component);
                },
                selection: {
                    mode: "single"
                },
                onRowClick: (e) => {
                    this.onProtectiveGridItemSelected(e.data);
                },
                columns: [
                    { dataField: "label", caption: "Holding", width: 130 },
                    { dataField: "label2", caption: "Description" },
                    { dataField: "value", caption: "Value", format: "currency", sortOrder: "desc", width: 68 },
                    { dataField: "value4", caption: "% of Asset Class", format: { type: "percent", precision: 1 }, width: 68 },
                    { dataField: "value2", caption: "Units", format: "fixedPoint", width: 68 }
                ],
            };

            this.dgProtectiveGroup = {
                export: {
                    enabled: true,
                    fileName: "ChartData"
                },
                bindingOptions: {
                    dataSource: "vm.dataProtectiveGroup"
                },
                //height: "350px",
                //width: "100%",
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                allowColumnResizing: true,
                columnResizingMode: "nextColumn",
                //scrolling: {
                //    mode: "standard",
                //    useNative: true
                //},
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                onContentReady: (e: any) => {
                    //this.showHideResizeCols(e.component);
                },
                selection: {
                    mode: "single"
                },
                onRowClick: (e) => {
                    this.onProtectiveGridItemSelected(e.data);
                },
                columns: [
                    { dataField: "label", caption: "Holding", width: 130 },
                    { dataField: "label2", caption: "Description" },
                    { dataField: "value", caption: "Value", format: "currency", sortOrder: "desc", width: 68 },
                    { dataField: "value3", caption: "% of Group", format: { type: "percent", precision: 1 }, width: 68 },
                    { dataField: "value2", caption: "Units", format: "fixedPoint", width: 68 }
                ],
            };

            //test data for protective stacked bar chart
            //this.protectiveData = [{
            //    assetClass: 'Equities',
            //    protectivePercentage: .5,
            //    nonProtectivePercentage: .5,
            //}, {
            //    assetClass: 'Fixed Income',
            //    protectivePercentage: .2,
            //    nonProtectivePercentage: .8,
            //}, {
            //    assetClass: 'Alternatives',
            //    protectivePercentage: .1,
            //    nonProtectivePercentage: .9,
            //}, {
            //    assetClass: 'Other',
            //    protectivePercentage: .35,
            //    nonProtectivePercentage: .65,
            // }];

            this.chartProtectiveGroupOptions = {
                argumentAxis: {
                    label: {
                        overlappingBehavior: "stagger",
                        staggeringSpacing: 3
                    }
                },
                animation: {
                    enabled: false
                },
                bindingOptions: {
                    dataSource: "vm.protectiveData"
                },
                commonSeriesSettings: {
                    argumentField: 'assetClass',
                    type: 'stackedBar',
                },
                series: [
                    { valueField: 'protectivePercentageOfGroup', name: 'Notes' },
                    { valueField: 'nonProtectivePercentageOfGroup', name: 'Other' },
                ],
                legend: {
                    verticalAlignment: 'bottom',
                    horizontalAlignment: 'center',
                    itemTextPosition: 'top',
                },
                onPointClick: (e: any) => {
                    this.onProtectiveGroupBarPointClick(e.target);
                },
                valueAxis: {
                    title: {
                        text: 'Percentage',
                    },
                    position: 'left'
                },
                export: {
                    enabled: false,
                },
                selectionMode: "onlyPoint",
                tooltip: {
                    enabled: true,
                    location: 'edge',
                    customizeTooltip(arg) {
                        return {
                            text: `${arg.seriesName}: ${Math.round(arg.valueText * 100) / 100}%`,
                        };
                    },
                },
            };

            this.chartProtectiveAssetClassOptions = {
                argumentAxis: {
                    label: {
                        overlappingBehavior: "stagger",
                        staggeringSpacing: 3
                    }
                },
                animation: {
                    enabled: false
                },
                bindingOptions: {
                    dataSource: "vm.protectiveData"
                },
                commonSeriesSettings: {
                    argumentField: 'assetClass',
                    type: 'stackedBar',
                },
                series: [
                    { valueField: 'protectivePercentageOfAssetClass', name: 'Notes' },
                    { valueField: 'nonProtectivePercentageOfAssetClass', name: 'Other' },
                ],
                legend: {
                    verticalAlignment: 'bottom',
                    horizontalAlignment: 'center',
                    itemTextPosition: 'top',
                },
                onPointClick: (e: any) => {
                    this.onProtectiveAssetClassBarPointClick(e.target);
                },
                valueAxis: {
                    title: {
                        text: 'Percentage',
                    },
                    position: 'left'
                },
                export: {
                    enabled: false,
                },
                selectionMode: "onlyPoint",
                tooltip: {
                    enabled: true,
                    location: 'edge',
                    customizeTooltip(arg) {
                        return {
                            text: `${arg.seriesName}: ${Math.round(arg.valueText * 100) / 100}%`,
                        };
                    },
                },
            };

            this.dgProtective = {
                export: {
                    enabled: true,
                    fileName: "ChartData"
                },
                bindingOptions: {
                    dataSource: "vm.dataProtective"
                },
                columnChooser: {
                    enabled: true,
                    mode: "dragAndDrop",
                    title: "Select columns",
                    width: 300
                },
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                columnResizingMode: "nextColumn",
                filterRow: { visible: true },
                headerFilter: { visible: true },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //onContentReady: (e: any) => {
                //},
                columns: [
                    {
                        caption: 'Note Details:', columns: [
                            // The server unmasks Orion's "22xxxxA57_9353426" into the real CUSIP where the
                            // mapping table has it; where it does not, fall back to the raw key rather
                            // than show a blank cell.
                            {
                                dataField: "cusip", caption: "CUSIP", width: 80,
                                calculateCellValue: (data: domains.ISecurityNote) => data.cusip || data.uniqueSecId
                            },
                            { dataField: "uniqueSecId", caption: "Security ID", width: 80, visible: false },
                            { dataField: "shortName", caption: "Short Name", width: 80 },
                            { dataField: "noteClass", caption: "Note Class", width: 65 },
                            { dataField: "issuerName", caption: "Issuer", width: 100 },
                            { dataField: "currency", caption: "Currency", width: 70 },
                            { dataField: "termMonths", caption: "Term", width: 50 },
                            { dataField: "issueDate", caption: "Issue Date", width: 70, dataType: 'date', format: 'shortDate', },
                            { dataField: "maturityDate", caption: "Maturity Date", width: 80, dataType: 'date', format: 'shortDate' },
                            { dataField: "timeRemainingMonths", caption: "Months Remaining", width: 85 }
                        ]
                    },
                    //{
                    //    caption: 'Underlying Info:', columns: [
                    //        { dataField: "securityNoteUnderlying.asOfDate", caption: "As Of Date", width: 65, dataType: 'date', format: 'shortDate' },
                    //        { dataField: "securityNoteUnderlying.underlyingReturn", caption: "Underlying Return", width: 90, format: { type: 'percent', precision: 2 } },
                    //        { dataField: "securityNoteUnderlying.percentToBreach", caption: "% to Breach", width: 65, format: { type: 'percent', precision: 2 } },
                    //        { dataField: "securityNoteUnderlying.breached", caption: "Breached", width: 80 }
                    //    ]
                    //},
                    {
                        caption: 'Note Valuation:', columns: [
                            //{ dataField: "securityNoteValuation.asOfDate", caption: "As Of Date", width: 65, dataType: 'date', format: 'shortDate' },
                            //{ dataField: "securityNoteValuation.couponType", caption: "Coupon Type", width: 80 },
                            //{ dataField: "securityNoteValuation.costBasis", caption: "Cost Basis", width: 70, format: { type: 'currency', precision: 2 } },
                            //{ dataField: "securityNoteValuation.valuation", caption: "Valuation", width: 70, format: { type: 'currency', precision: 2 } },
                            //{ dataField: "securityNoteValuation.couponSummary", caption: "Coupon Summary", width: 70 },
                            //{ dataField: "securityNoteValuation.couponProbability", caption: "Coupon Probability", width: 90, format: { type: 'percent', precision: 2 } },
                            //{ dataField: "securityNoteValuation.couponsRemaining", caption: "Coupons Remaining", width: 90 },
                            //{ dataField: "securityNoteValuation.callProbability", caption: "Call Probability", width: 90, format: { type: 'percent', precision: 2 } },
                            //{ dataField: "securityNoteValuation.nextObservationDate", caption: "Next Observation Date", width: 120, dataType: 'date', format: 'shortDate' },
                            { dataField: "securityNoteValuation.annualizedYield", caption: "Annualized Yield", width: 120, format: { type: 'percent', precision: 2 } },
                            { dataField: "securityNoteValuation.finalValuationDate", caption: "Final Valuation Date", width: 110, dataType: 'date', format: 'shortDate' },
                        //    { dataField: "securityNoteValuation.fixedParticipation", caption: "Fixed Participation", width: 100, format: { type: "percent", precision: 2 } },
                        //    { dataField: "securityNoteValuation.noteReturn", caption: "Note Return", width: 60, format: { type: 'percent', precision: 2 } },
                        //    { dataField: "securityNoteValuation.realizedMaturityValue", caption: "Realized Maturity Value", width: 100, format: { type: 'currency', precision: 2 } },
                        //    { dataField: "securityNoteValuation.fixedCoupon", caption: "Fixed Coupon", width: 80, format: { type: 'percent', precision: 2 } },
                        //    { dataField: "securityNoteValuation.participationPlus", caption: "Participation Plus", width: 100, format: { type: "fixedPoint", precision: 2 } }
                        ]
                    },
                //    {
                //        caption: 'Portfolio:', columns: [
                //            { dataField: "securityNotePortfolio.asOfDate", caption: "As Of Date", width: 65, dataType: 'date', format: 'shortDate' },
                //            { dataField: "securityNotePortfolio.notional", caption: "Notional", width: 70, format: { type: 'currency', precision: 0 } },
                //            { dataField: "securityNotePortfolio.unrealizedGainLoss", caption: "Unrealized G/L", width: 90, format: { type: 'percent', precision: 2 } },
                //            { dataField: "securityNotePortfolio.marketValue", caption: "Market Value", width: 100, format: { type: 'currency', precision: 2 } },
                //            { dataField: "securityNotePortfolio.annualCouponIfPaid", caption: "Annual Coupon If Paid", width: 90, format: { type: 'percent', precision: 2 } },
                //            { dataField: "securityNotePortfolio.couponAmount", caption: "Coupon Amount", width: 65, format: { type: 'currency', precision: 2 } }
                //        ]
                //    },
                //    {
                //        caption: 'If Note Matured Today:', columns: [
                //            { dataField: "securityNoteAsOf.matureTodayReturnAtMaturity", caption: "Return At Maturity", width: 80, format: { type: 'percent', precision: 2 } },
                //            { dataField: "securityNoteAsOf.matureTodayValueAtMaturity", caption: "Value At Maturity", width: 100, format: { type: 'currency', precision: 2 } }
                //        ]
                //    }
                ],
                summary: {
                    totalItems:
                        [
                            {
                                column: "cusip",
                                name: "Count",
                                summaryType: "count"
                            },
                    //        {
                    //            column: "securityNotePortfolio.notional",
                    //            name: "Notional",
                    //            valueFormat: "currency",
                    //            summaryType: "sum"
                    //        },
                    //        {
                    //            column: "securityNotePortfolio.marketValue",
                    //            name: "Market Value",
                    //            valueFormat: "currency",
                    //            summaryType: "sum"
                    //        }
                    ]
                },
            };

            this.piPopupOptions = {
                deferRendering: false,
                width: 600,
                height: 700,
                showTitle: true,
                title: "Instrument Details",
                dragEnabled: true,
                closeOnOutsideClick: true,
                showCloseButton: true,
                bindingOptions: {
                    visible: "vm.visibleProtectivePopup",
                },
            };

            this.scrollViewOptions = {
                width: '100%',
                height: '100%',
            };

        }

        closeProtectivePopup() {
            this.visibleProtectivePopup = false;
        }

        //onChangeProtectiveView() {
        //    if (this.showProtChart) {
        //        // show the chart that corresponds to the selected pie chart
        //    } else {
        //    }
        //}

        onProtectiveGroupBarPointClick = (e) => {
            const chartIndex = e.index;
            const seriesName = e.series.name;
            const chartData = this.chartData[this.selChartType.id].data[chartIndex];
            const protectiveFilter: boolean = (seriesName == "Notes");

            this.dataProtectiveGroup = chartData.bySecurityTypes.filter(f => f.isProtective == protectiveFilter);;
            let dgProtectiveGroup = DevExpress.ui.dxDataGrid.getInstance($('#dgHdAccountsProtectiveGroup')) as DevExpress.ui.dxDataGrid;
            if (dgProtectiveGroup) {
                dgProtectiveGroup.refresh();
            }
        }

        onProtectiveAssetClassBarPointClick = (e) => {
            const chartIndex = e.index;
            const seriesName = e.series.name;
            const chartData = this.chartData[this.selChartType.id].data[chartIndex];
            const protectiveFilter: boolean = (seriesName == "Notes");

            // Populate the associated data grid with the associated holdings data
            this.dataProtectiveAssetClass = chartData.bySecurityTypes.filter(f => f.isProtective == protectiveFilter);;
            let dgProtectiveAssetClass = DevExpress.ui.dxDataGrid.getInstance($('#dgHdAccountsProtectiveAssetClass')) as DevExpress.ui.dxDataGrid;
            if (dgProtectiveAssetClass) {
                dgProtectiveAssetClass.refresh();
            }
        }

        onProtectiveGridItemSelected = (e) => {
            //console.log("GRID ITEM SELECTED", e);
            if (e.isProtective) {
                this.visibleProtectivePopup = false;
                const instrumentId = e.idUniqueStr;
                //console.log("INSTRUMENT UNIQUEID", instrmentId);
                this.advisorService.getProtectiveSecurityDetails(instrumentId)
                    .then((data) => {
                        this.protectiveInstrument = data.data;
                        this.visibleProtectivePopup = true;
                    })
                    .catch((reason) => {
                        //console.log("Error during load household");
                        //console.log(reason);
                        //throw reason;
                    });
            }
        }

        chartInitialized(chart) {
            // console.log(`Chart Initialised`, chart);
            this.chartInstance = chart;
        }

        histChartInitialized(chart) {
            // console.log(`Hist Chart Initialised`, chart);
            this.histChartInstance = chart;
        }

        slicingEnd = (event, args) => {

            // for this categories we will not show analitics by SecurityType
            if (this.selChartType.chartid == this.chartId_BY_SECURITY_CATEGORY ||
                this.selChartType.chartid == this.chartId_BY_SECURITY) {
                return;
            }

            const chartData = this.chartData[this.selChartType.id].data;
            const sliceData = chartData.filter(v => v.label == args.data.label)[0];

            if (args.slicedState && chartData && sliceData) {
                const dataBySecType = sliceData.bySecurityTypes;

                if (dataBySecType && dataBySecType.length) {
                    // If the immediate children are themselves asset classes (each with its
                    // own bySecurityTypes), the user is drilling into a parent asset class.
                    // The secondary pie shows the child asset classes; the grid below mirrors
                    // the secondary pie until the user clicks a slice to drill into securities.
                    const hasChildAssetClasses = dataBySecType.some((d: any) => d.bySecurityTypes && d.bySecurityTypes.length);
                    const flatSecurities: domains.IChartData[] = hasChildAssetClasses
                        ? dataBySecType.reduce((acc: domains.IChartData[], d: any) => acc.concat(d.bySecurityTypes || []), [])
                        : dataBySecType;

                    this.titleData = `${this.chartData[this.selChartType.id].chart.caption} - ${sliceData.label} by Security`;
                    // Grid initially mirrors the secondary pie: asset classes when hierarchical, securities otherwise
                    this.data = dataBySecType;
                    this.currentChartTypeId = hasChildAssetClasses
                        ? this.chartId_BY_ASSET_CLASS_CUSTOM
                        : this.chartId_BY_SECURITY;

                    // Populate secondary pie chart with the holdings (or child asset classes) for this slice
                    this.allBySecurityData = dataBySecType;
                    this.flattenedSecurities = flatSecurities;
                    this.selectedSliceLabel = sliceData.label;
                    this.sliceTitle = `${sliceData.label} - Holdings Breakdown`;
                    this.chartSlice.data = dataBySecType as any;
                    this.showSliceChart = true;
                    // Force re-render so FusionCharts picks up new data
                    this.showSliceChartRender = false;
                    setTimeout(() => { this.showSliceChartRender = true; }, 0);

                    let dg = DevExpress.ui.dxDataGrid.getInstance($('#dgChartHdAccounts')) as DevExpress.ui.dxDataGrid;
                    if (dg) {
                        this.showHideResizeCols(dg);
                        dg.refresh();
                    }
                    return;
                }
            }

            // back to the original state - hide the secondary pie
            this.showSliceChart = false;
            this.sliceTitle = "";
            this.selectedSliceLabel = "";
            this.allBySecurityData = [];
            this.flattenedSecurities = [];
            this.chartSlice.data = [];
            this.updateDataGrid();
        }

        sliceChartSlicingEnd = (event, args) => {
            // When a slice on the secondary pie is clicked:
            //  - if it represents an asset class (has its own bySecurityTypes), drill the
            //    grid into that class's underlying securities;
            //  - otherwise (it's a single security), filter the grid to that single holding.
            // When unsliced, restore grid to mirror the secondary pie (asset classes when
            // hierarchical, securities otherwise).
            if (!this.allBySecurityData || !this.allBySecurityData.length) {
                return;
            }

            if (args.slicedState) {
                const single = this.allBySecurityData.filter(v => v.label == args.data.label);
                if (single && single.length) {
                    const child: any = single[0];
                    if (child.bySecurityTypes && child.bySecurityTypes.length) {
                        this.data = child.bySecurityTypes;
                        this.currentChartTypeId = this.chartId_BY_SECURITY;
                    } else {
                        this.data = single;
                    }
                }
            } else {
                this.data = this.allBySecurityData;
                if (this.flattenedSecurities && this.flattenedSecurities.length
                    && this.flattenedSecurities !== this.allBySecurityData) {
                    this.currentChartTypeId = this.chartId_BY_ASSET_CLASS_CUSTOM;
                }
            }

            let dg = DevExpress.ui.dxDataGrid.getInstance($('#dgChartHdAccounts')) as DevExpress.ui.dxDataGrid;
            if (dg) {
                this.showHideResizeCols(dg);
                dg.refresh();
            }
        }

        showHideResizeCols(dg: DevExpress.ui.dxDataGrid) {
            //chartId_BY_ACCOUNT_TYPE: number = 1;
            //chartId_BY_ACCOUNT_STRATEGY: number = 2;
            //chartId_BY_ASSET_CLASS: number = 3; // NOT USED CURRENTLY
            //chartId_BY_ASSET_CLASS_CUSTOM: number = 4;
            //chartId_BY_SECURITY_TYPE: number = 5;
            //chartId_BY_SECURITY_CATEGORY: number = 6; // NOT USED CURRENTLY
            //chartId_BY_SECURITY: number = 7;
            //chartId_BY_ACCOUNT: number = 8;

            // show/hide columns
            if (this.currentChartTypeId == this.chartId_BY_SECURITY) {
                dg.columnOption("label2", "visible", true);
                dg.columnOption("value2", "visible", true);
            } else {
                dg.columnOption("label2", "visible", false);
                dg.columnOption("value2", "visible", false);
            }

            //console.log("CHART TYPE ID IS:", this.currentChartTypeId);

            // set column widths
            if (this.currentChartTypeId == this.chartId_BY_ACCOUNT_TYPE) {
                //console.log("SETTING FOR chartId_BY_ACCOUNT_TYPE");
                dg.columnOption("label", "width", "160px");
            } else if (this.currentChartTypeId == this.chartId_BY_ACCOUNT_STRATEGY) {
                //console.log("SETTING FOR chartId_BY_ACCOUNT_STRATEGY");
                dg.columnOption("label", "width", "320px");
                //} else if (this.currentChartTypeId == this.chartId_BY_ASSET_CLASS) {
            } else if (this.currentChartTypeId == this.chartId_BY_ASSET_CLASS_CUSTOM) { // 4
                //console.log("SETTING FOR chartId_BY_ASSET_CLASS_CUSTOM");
                dg.columnOption("label", "width", "160px");
            } else if (this.currentChartTypeId == this.chartId_BY_SECURITY_TYPE) {
                //console.log("SETTING FOR chartId_BY_SECURITY_TYPE");
                dg.columnOption("label", "width", "200px");
                //} else if (this.currentChartTypeId == this.chartId_BY_SECURITY_CATEGORY) {
            } else if (this.currentChartTypeId == this.chartId_BY_SECURITY) {
                //console.log("SETTING FOR chartId_BY_SECURITY");
                dg.columnOption("label", "width", "130px");
                dg.columnOption("label2", "width", "190px");
            } else if (this.currentChartTypeId == this.chartId_BY_ACCOUNT) { // 8
                //console.log("SETTING FOR chartId_BY_ACCOUNT");
                dg.columnOption("label", "width", "320px");
            }
            dg.columnOption("value", "width", "68px");
            dg.columnOption("value2", "width", "68px");
            dg.columnOption("value3", "width", "68px");
        }

        GetDetails(item: domains.IChartData): DevExpress.ui.dxDataGridOptions {
            this.dataBySecurity = [];
            this.dataBySecurity = item.bySecurityTypes;
            return this.dgBySecurity;
        }

        updateDataGrid() {
            // Data Grid Update
            if (this.selChartType) {
                this.data = this.chartData[this.selChartType.id].data;
                this.currentChartTypeId = this.selChartType.chartid;
                this.masterChartTypeId = this.selChartType.chartid;
                let dg = DevExpress.ui.dxDataGrid.getInstance($('#dgChartHdAccounts')) as DevExpress.ui.dxDataGrid;
                if (dg) {
                    this.showHideResizeCols(dg);
                    dg.refresh();
                }
            }
        }

        setChartAttributes(histChartType: string) {
            // type 1 - percentage-based
            // type 2 - value-based
            // type 3 - value only
            this.histChart.chart.showPercentValues = (histChartType == "1") ? "1" : "0";
            this.histChart.chart.stack100Percent = (histChartType == "1") ? "1" : "0";
            this.histChart.chart.interactiveLegend = (histChartType == "1") ? "0" : "1";
        }

        chartTypeChanged() {
            this.currentChartChanged();
            this.histChartChanged();
        }

        currentChartChanged() {
            // console.log(`Loading chart... `, this.selChartType);
            if (this.selChartType) {
                //console.log("IN CHART TYPE CHANGED, SELECTED CHART TYPE IS:", this.selChartType);
                //console.log("ALLOW PROTECTIVE CHARTS:", this.allowProtectiveCharts);
                //console.log(`ChartTypeChanged, chart data: `, this.chartData[this.selChartType.id]);

                //console.log("CHARTDATA", this.chartData);
                // Pie Chart Update - destroy and recreate FusionCharts to clear stale internal event state
                this.chart.data = this.chartData[this.selChartType.id].data;
                this.titleData = this.chartData[this.selChartType.id].chart.caption;
                this.showChart = false;
                setTimeout(() => { this.showChart = true; }, 0);

                // Reset secondary pie state on chart-type change
                this.showSliceChart = false;
                this.sliceTitle = "";
                this.selectedSliceLabel = "";
                this.allBySecurityData = [];
                this.chartSlice.data = [];

                this.updateDataGrid();
                // Protective Chart Updates
                // clear out data grids that populate when bar is selected
                this.dataProtectiveAssetClass = [];
                this.dataProtectiveGroup = [];
                if (this.currentChartTypeId == this.chartId_BY_ASSET_CLASS_CUSTOM && this.allowProtectiveCharts) {
                    this.protectiveData = []
                    this.chartData[this.selChartType.id].data.forEach(d => this.protectiveData.push({
                        assetClassId: d.protectiveComposition.assetClassId,
                        assetClass: d.protectiveComposition.assetClass,
                        valueOfAssetClass: d.protectiveComposition.valueOfAssetClass,
                        valueOfGroup: d.protectiveComposition.valueOfGroup,
                        protectiveValue: d.protectiveComposition.protectiveValue,
                        protectivePercentageOfAssetClass: d.protectiveComposition.protectivePercentageOfAssetClass,
                        protectivePercentageOfGroup: d.protectiveComposition.protectivePercentageOfGroup,
                        nonProtectiveValue: d.protectiveComposition.nonProtectiveValue,
                        nonProtectivePercentageOfAssetClass: d.protectiveComposition.nonProtectivePercentageOfAssetClass,
                        nonProtectivePercentageOfGroup: d.protectiveComposition.nonProtectivePercentageOfGroup
                    }));
                    this.protectiveChartsEnabled = true;
                } else {
                    this.protectiveChartsEnabled = false;
                    this.showProtAnalysis = false;
                    this.showProtChart = false;
                }
                // Protctive instruments grid Update
                this.dataProtective = this.chartData[this.selChartType.id].protectiveInstruments;
            }
        };

        histChartChanged() {
            // console.log(`Loading chart... `, this.selChartType);
            if (this.selChartType) {
                //console.log("IN CHART TYPE CHANGED, SELECTED CHART TYPE IS:", this.selChartType);
                //console.log(`ChartTypeChanged, chart data: `, this.chartData[this.selChartType.id]);
                //console.log("HISTCHARTDATA", this.histChartData);

                // At this time we will not show BY SECURITY historical charts, client has asked not to show this chart
                if (this.selChartType.chartid == this.chartId_BY_SECURITY) {
                    this.localChartHide = true;
                } else {
                    this.localChartHide = false;
                }

                if (this.histChartDataExists && this.histChartData && this.histChartData.length > 0 && this.histChartData[0].dataset.length > 0) {
                    this.histChart.dataset = this.histChartData[this.selChartType.id].dataset;
                    this.histChart.categories = this.histChartData[this.selChartType.id].categories;
                    //this.histTitleData = this.histChartData[this.selChartType.id].chart.caption;
                    if (this.histChartInstance != null) {
                        this.histChartInstance.render();
                    }
                    //this.histChart.chart.showPercentValues = this.stackPercentAttribute ? "1" : "0";
                    //this.histChart.chart.stack100Percent = this.stackPercentAttribute ? "1" : "0";
                    //this.histChart.chart.interactiveLegend = this.stackPercentAttribute ? "0" : "1";
                }
                if (this.clearHistChartData) {
                    this.histChart.dataset = [];
                    this.titleData = "Chart data loading...";
                    if (this.histChartInstance != null) {
                        this.histChartInstance.render();
                    }
                    this.clearHistChartData = false;
                }
                if (this.selChartType.chartid == this.chartId_BY_SECURITY) {
                    this.histChartNote = "Note: Only showing securities that comprise the top 5 securities held on any of the dates below.";
                } else {
                    this.histChartNote = null;
                }
            }
        };

        $onChanges(evt) {
            for (var key in evt) {
                if (key === "chartData" && this.chartData) {

                    this.chartTypes = [];
                    for (var i = 0; i < this.chartData.length; i++) {
                        this.chartTypes.push({ id: i, chartid: this.chartData[i].chartId, name: this.chartData[i].chartName });
                    }

                    // However, if this selection supports a chart of the same type that is currently being viewed,
                    // then keep the same chart type
                    for (var i = 0; i < this.chartTypes.length; i++) {
                        if (this.chartTypes[i].chartid == this.masterChartTypeId) {
                            this.selChartType = this.chartTypes[i];
                            break;
                        }
                        this.selChartType = this.chartTypes[0]; // default to first chart in list
                    }

                    //console.log("ABOUT TO CALL CHARTTYPECHANGED: chartData is:", this.chartData);
                    this.currentChartChanged();
                }
                if (key === "histChartData" && this.histChartData) {

                    this.histChartChanged();
                }
            }
        }

        $onInit(): void {
            this.iAmReady({ ctrl: this });
        }

        $routerOnActivate(next, previous) {
        }
    }



    class ChartHdAccounts implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public transclude;

        constructor() {
            this.bindings = {
                allowProtectiveCharts: "<",
                chartData: "<",
                showHistChart: "<",
                histChartData: "<",
                advDash: "<",
                iAmReady: "&"
            };
            this.transclude = {
                ddlaccounts: "?ddlAccounts",
                histselect: "?histSelect",
                histoptions: "?histOptions"
            };
            this.controller = ["advisorService", ChartHdAccountsController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/chart-hd-accounts.html';
        }
    }
    angular.module(Constants.APP).component("chartHdAccounts", new ChartHdAccounts());

}